module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "snickers.1cbde1f0.svg";